import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const fetchAgronegocioNews = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/news/agronegocio`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar notícias:', error);
    throw error;
  }
};
